const INPUT_SELECTOR = '.in-integer';
const INVALID_CHARS = [
    '.',
];

const IntegerInput = {
    init: ($scope) => {
        if (!$scope) {
            $scope = $(document);
        }

        $scope.on('keydown', INPUT_SELECTOR, function (event) {
            if (INVALID_CHARS.includes(event.key.toLowerCase())) {
                event.preventDefault();
            }
        });
    },
};

export default IntegerInput;
